import useSWR from "swr";
import { JSON_FETCHER } from "@/components/fetcher";

export type CompanyAddress = {
  line1: string | null;
  line2: string | null;
  city: string | null;
  state: string | null;
  postal_code: string | null;
  country: string | null;
};

export type CompanyTaxId = {
  id: string;
  type: string;
  value: string;
};

export type CompanyInfo = {
  name: string | null;
  address: CompanyAddress | null;
  tax_id: CompanyTaxId | null;
};

export default function useCompanyInfo(): {
  companyInfo: CompanyInfo | null;
  isLoading: boolean;
  isError: unknown;
} {
  const { data, error } = useSWR("/web_api/billing/company_info", JSON_FETCHER);

  const companyInfo: CompanyInfo | null =
    data && data.status === "ok"
      ? {
          name: data.name ?? null,
          address: data.address ?? null,
          tax_id: data.tax_id ?? null,
        }
      : null;

  return {
    companyInfo,
    isLoading: !(data || error),
    isError: error,
  };
}
